import { ISearchQuery } from "../../../shared/hooks/useSearch"
import { AddFormToCaseActionTypes, ICreateFormForCaseAction, IFetchFormsForCaseAsyncAction, IMarkFormCompleteAction as IMarkCaseFormCompleteAction } from "./addFormToCaseTypes"

export const fetchFormsForCaseAsync = (searchQuery: ISearchQuery): IFetchFormsForCaseAsyncAction => {
  return {
    type: AddFormToCaseActionTypes.FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_PENDING,
    payload: searchQuery
  }
}

export const createFormForCaseAction = (caseId: string, formTemplateId: string, meetingCaseId?: string): ICreateFormForCaseAction => {
  return {
    type: AddFormToCaseActionTypes.CREATE_FORM_FOR_CASE_ASYNC_PENDING,
    payload: {
      caseId,
      formTemplateId,
      meetingCaseId
    }
  }
}

export const markFormCompleteAction = (caseId: string, formId: string): IMarkCaseFormCompleteAction => {
  return {
    type: AddFormToCaseActionTypes.MARK_FORM_COMPLETE_ASYNC_PENDING,
    payload: {
      caseId,
      formId
    }
  }
}
